// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0c1178c4","147":"4465a02f","152":"3bd8652f","198":"5c830e18","290":"d67e286c","362":"a719ab9e","404":"3ac5f455","480":"f24f6d1e","541":"c018dc96","579":"1b3837eb","854":"d3b510e0"}[chunkId] + ".chunk.js";
};